export function findDifferences(obj1, obj2) {
    if (!obj1 || !obj2) return {};

    const diffs = {};

    Object.keys({ ...obj1, ...obj2 }).forEach((key) => {
        if (Array.isArray(obj1[key]) && Array.isArray(obj2[key])) {
            obj1[key].forEach((row) => {
                const existInObj = obj2[key].some(item => JSON.stringify(item) === JSON.stringify(row));
                if (!existInObj) {
                    if (!diffs[key]) {
                        diffs[key] = [];
                    }
                    diffs[key].push(row);
                }
            });
            obj2[key].forEach((row) => {
                const existInObj = obj1[key].some(item => JSON.stringify(item) === JSON.stringify(row));
                if (!existInObj) {
                    if (!diffs[key]) {
                        diffs[key] = [];
                    }
                    diffs[key].push(row);
                }
            });
        } else if (Array.isArray(obj1[key]) || Array.isArray(obj2[key])) {
            if (Array.isArray(obj1[key])) {
                obj1[key].forEach((row) => {
                    if (!diffs[key]) {
                        diffs[key] = [];
                    }
                    diffs[key].push(row);
                });
            } else {
                obj2[key].forEach((row) => {
                    if (!diffs[key]) {
                        diffs[key] = [];
                    }
                    diffs[key].push(row);
                });
            }
        } else {
            if (JSON.stringify(obj1[key]) !== JSON.stringify(obj2[key])) {
                diffs[key] = { value1: obj1[key], value2: obj2[key] };
            }
        }
    });
    
    return diffs;
}